module.exports = "/_next/static/images/362f16f2aed62da664e827b72b4eb8f3-cuenta.svg";